import React, { useEffect, useRef, useState } from "react";
import "../assets/css/custom.css";
import "../assets/css/client.css";
import "../assets/css/font-awesome.css";
import "../assets/css/sweetalert.css";
// import { Users, Star } from "react-feather";
import "../assets/css/bootstrap.min.css";
import "../assets/css/steps.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBuilding,
  faDoorOpen,
  faEdit,
  faPlus,
  faSort,
  faTowerObservation,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import clientlogo from "../assets/img/user1.jpg";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useNavigate, Link } from "react-router-dom";
import ReactDOM from "react-dom";
import client from "../assets/img/client.png";
import AppSettingImg from "../assets/img/appsetting.png";
import UserTagImg from "../assets/img/userTag.png";
import manageRfid from "../assets/img/managerfid.png"
import building from "../assets/img/building.png";
import office from "../assets/img/office.png";
import apartment from "../assets/img/apartment.png";
import gate from "../assets/img/gate.png";
import brand from "../assets/img/reputation.png";
import company from "../assets/img/enterprise.png";
import Accesskey from "../assets/img/Accesskey.png";
import gateGroup from "../assets/img/level.png";

import Client from "./client";
import Menus from "./menus";
import Building from "./building";
import Tower from "./tower";
import Flat from "./flat";
import Gate from "./Gate";
import Brand from "./brand";
import Company from "./company";
import ManageRfid from "./ManageRFID";
import ApplicationSettings from "./ApplicationSettings";
import { Offline, Online } from "react-detect-offline";
import NoInternet from "./Nointernet";
import Category from "./Category";
import Subcategory from "./Subcategory";
import ManageUserRfid from "./UserRfid";
import AccessControlType from "./AccessContolType";
import GroupGate from "./GroupGate";



function Configuration() {
  const history = useNavigate();
  const [activeTab, setActiveTab] = useState("tab1");
  
  const [showMobileSubMenu, setShowMobileSubMenu] = useState(false)
  const handleTabChange = (tab) => {
    console.log("Initial Tab", tab)
    localStorage.setItem("lastTab", tab)
    setActiveTab(tab);
  };
  const [reset, setReset] = useState(0);
  useEffect(() => {
    const storedUsername = localStorage.getItem('userData');
    const myUserData = JSON.parse(storedUsername);
    console.log("useEffect Local storage name", storedUsername)
    if (storedUsername) {
      // If the username is present, redirect to the dashboard
      if(myUserData?.roleName == "Society Admin" || myUserData?.roleName == "Support Admin" || myUserData?.roleName == "Super Admin" || myUserData?.roleName == "Society Operator"){
        if(myUserData?.roleName == "Support Admin" || myUserData?.roleName == "Super Admin"){
          history('/Configuration');
          console.log("useEffect Local storage Yes")
          return
        }else{
            history('/Dashboard');
            return
        } 
        
      // alert("Hello")
      }else{
        history('/Dashboard');
        console.log("useEffect Local storage Yes")
        return
      }  
      
    }
    else if (!storedUsername) {
      history('/');
      console.log("useEffect Local storage No")
    }
  }, [history]);

  useEffect(() => {
    localStorage.setItem("lastTabApproval", "tab1")
    localStorage.setItem("lastTabManagent", "tab1")
    localStorage.setItem("lastTabUtility", "tab1")
    const lastTab = localStorage.getItem("lastTab");
    if (!lastTab) {
      setActiveTab("tab1")
    }
    else {
      console.log(lastTab, "lastTTT")
      setActiveTab(lastTab)
    }

  }, [])

  


  return (
    <>
      <Menus />
      <section className="tabular_intergration">
        <div className="tab-container">
          <div className="UnderBox-Shadow">
            <div className="container-fluid py-0 px-0 hideContainer">
              <div className="row">
                <div className="col-lg-12 col-dm-12 col-sm-12 col-12">
                  <div className="tabs d-flex">
                    <button
                      className={activeTab === "tab1" ? "active-tab" : "subfeildbtn d-flex align-items-center"}
                      style={{ padding: "8px 12px 5px" }}
                      onClick={() => handleTabChange("tab1")}
                    >
                      <img src={client} className="img" style={{ width: "21px", marginRight: "5px" }} />{"  "} Clients
                    </button>
                    <button
                      className={activeTab === "tab2" ? "active-tab" : "subfeildbtn d-flex align-items-center"}
                      style={{ padding: "8px 12px 5px" }}
                      onClick={() => handleTabChange("tab2")}
                    >
                      <img src={building} className="img" style={{ width: "21px", marginRight: "5px" }} /> Buildings
                    </button>
                    <button
                      className={activeTab === "tab3" ? "active-tab" : "subfeildbtn d-flex align-items-center"}
                      style={{ padding: "8px 12px 5px" }}
                      onClick={() => handleTabChange("tab3")}
                    >
                      <img src={office} className="img" style={{ width: "24px", }} />Towers
                    </button>
                    <button
                      className={activeTab === "tab4" ? "active-tab" : "subfeildbtn d-flex align-items-center"}
                      style={{ padding: "8px 12px 5px" }}
                      onClick={() => handleTabChange("tab4")}
                    >
                      <img src={apartment} className="img" style={{ width: "19px", marginRight: "5px" }} /> Flats
                    </button>
                    <button
                      className={activeTab === "tab5" ? "active-tab" : "subfeildbtn d-flex align-items-center"}
                      style={{ padding: "8px 12px 5px" }}
                      onClick={() => handleTabChange("tab5")}
                    >
                      <img src={gate} className="img" style={{ width: "20px" }} /> Gates
                    </button>
                    <button
                    className={activeTab === "tab6" ? "active-tab" : "subfeildbtn"}
                    style={{ padding: "8px 12px 5px" }}
                    onClick={() => handleTabChange("tab6")}
                    >
                        <img src={manageRfid} className="img" style={{ width: "21px", marginRight: 5 }} /> Tags
                    </button>
                    <button
                      className={activeTab === "tab7" ? "active-tab" : "subfeildbtn"}
                      style={{ padding: "8px 12px 5px" }}
                      onClick={() => handleTabChange("tab7")}
                    >
                      <img src={company} className="img" style={{ width: "21px",marginRight:"5px" }} />
                      Company
                    </button>
                    <button
                      className={activeTab === "tab8" ? "active-tab" : "subfeildbtn"}
                      style={{ padding: "8px 12px 5px" }}
                      onClick={() => handleTabChange("tab8")}
                    >
                      <img src={AppSettingImg} className="img" style={{ width: "21px",marginRight:"5px" }} />
                      App Settings
                    </button>
                    <button
                      className={activeTab === "tab9" ? "active-tab" : "subfeildbtn"}
                      style={{ padding: "8px 12px 5px" }}
                      onClick={() => handleTabChange("tab9")}
                    >
                      <img src={UserTagImg} className="img" style={{ width: "21px",marginRight:"5px", filter: "invert(1)" }} />
                      User RFID
                    </button>
                    <button
                      className={activeTab === "tab10" ? "active-tab" : "subfeildbtn"}
                      style={{ padding: "8px 12px 5px" }}
                      onClick={() => handleTabChange("tab10")}
                    >
                      <img src={Accesskey} className="img" style={{ width: "22px",marginRight:"5px", filter: "invert(1)" }} />
                      Access Type
                    </button>
                    <button
                      className={activeTab === "tab11" ? "active-tab" : "subfeildbtn"}
                      style={{ padding: "8px 12px 5px" }}
                      onClick={() => handleTabChange("tab11")}
                    >
                      <img src={gateGroup} className="img" style={{ width: "21px",marginRight:"5px", filter: "invert(1)" }} />
                      Group Gate
                    </button>
                    
                    {/* <button
                          className={activeTab === "tab6" ? "active-tab" : "subfeildbtn"}
                          onClick={() => handleTabChange("tab6")}
                          >
                          <img src={brand} className="img" style={{ width: "20px" }} /> Brand
                          </button>
       </div>                   <button
                          className={activeTab === "tab7" ? "active-tab" : "subfeildbtn"}
                          onClick={() => handleTabChange("tab7")}
                          >
                          <img src={brand} className="img" style={{ width: "20px" }} /> Company
                          </button> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>




      <div className="mobileViewSubMenu">
        <div className="rebon" onClick={() => { setShowMobileSubMenu(!showMobileSubMenu) }}>
          {showMobileSubMenu === false && <FaChevronDown className="rebonChevron" size="12px" />}
          {showMobileSubMenu === true && <FaChevronUp className="rebonChevron" size="12px" />}
        </div>
        <div className={`submenu ${showMobileSubMenu ? "open" : "closed"}`}>
          <div className="row">
            <div className="col-lg-12 col-dm-12 col-sm-12 col-12">
              <div className="tabs">
                <button
                  className={activeTab === "tab1" ? "active-tab" : "subfeildbtn"}
                  onClick={() => handleTabChange("tab1")}
                >
                  <img src={client} className="img" style={{ width: "21px" }} />Clients
                </button>
                <button
                  className={activeTab === "tab2" ? "active-tab" : "subfeildbtn"}
                  onClick={() => handleTabChange("tab2")}
                >
                  <img src={building} className="img" style={{ width: "21px" }} />Buildings
                </button>
                <button
                  className={activeTab === "tab3" ? "active-tab" : "subfeildbtn"}
                  onClick={() => handleTabChange("tab3")}
                >
                  <img src={office} className="img" style={{ width: "24px" }} />Towers
                </button>
                <button
                  className={activeTab === "tab4" ? "active-tab" : "subfeildbtn"}
                  onClick={() => handleTabChange("tab4")}
                >
                  <img src={apartment} className="img" style={{ width: "19px" }} />Flats
                </button>
                <button
                  className={activeTab === "tab5" ? "active-tab" : "subfeildbtn"}
                  onClick={() => handleTabChange("tab5")}
                >
                  <img src={gate} className="img" style={{ width: "20px" }} />Gates
                </button>
                <button
                className={activeTab === "tab6" ? "active-tab" : "subfeildbtn"}
                onClick={() => handleTabChange("tab6")}
                >
                    <img src={manageRfid} className="img" style={{ width: "21px", marginRight: 5 }} /> Tags
                </button>
                <button
                  className={activeTab === "tab7" ? "active-tab" : "subfeildbtn"}
                  onClick={() => handleTabChange("tab7")}
                >
                  <img src={company} className="img" style={{ width: "21px",marginRight:"5px" }} />
                  Company
                </button>
                <button
                  className={activeTab === "tab8" ? "active-tab" : "subfeildbtn"}
                  onClick={() => handleTabChange("tab8")}
                >
                  <img src={AppSettingImg} className="img" style={{ width: "21px",marginRight:"5px" }} />
                  App Settings
                </button>
                <button
                  className={activeTab === "tab9" ? "active-tab" : "subfeildbtn"}
                  onClick={() => handleTabChange("tab9")}
                >
                  <img src={UserTagImg} className="img" style={{ width: "21px",marginRight:"5px", filter: "invert(1)" }} />
                  User RFID
                </button>
                <button
                  className={activeTab === "tab10" ? "active-tab" : "subfeildbtn"}
                  onClick={() => handleTabChange("tab10")}
                >
                  <img src={UserTagImg} className="img" style={{ width: "21px",marginRight:"5px", filter: "invert(1)" }} />
                  Access Type
                </button>
                <button
                  className={activeTab === "tab10" ? "active-tab" : "subfeildbtn"}
                  onClick={() => handleTabChange("tab11")}
                >
                  <img src={UserTagImg} className="img" style={{ width: "21px",marginRight:"5px", filter: "invert(1)" }} />
                  Group Gate
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>


      <section className="whole_bColor">
        <div className="container-fluid">
          <div className='row'>
            <div className="col-12 ">

              <div>
                
                {activeTab === "tab1" && (
                  <div>
                      <Client />
                  </div>
                )}
                {activeTab === "tab2" && (
                  <div>
                      <Building />
                  </div>
                )}
                {activeTab === "tab3" && (
                  <div>
                      <Tower />
                  </div>
                )}
                {activeTab === "tab4" && (
                  <div>
                    <Flat />
                  </div>
                )}
                {activeTab === "tab5" && (
                  <div>
                    <Gate />
                  </div>
                )}
                {activeTab === "tab6" && (
                  <div>
                    <ManageRfid />
                  </div>
                )}
                {activeTab === "tab7" && (
                  <div>
                    <Company />
                  </div>
                )}
                {activeTab === "tab8" && (
                  <div>
                    <ApplicationSettings />
                  </div>
                )}
                {activeTab === "tab9" && (
                  <div>
                    <ManageUserRfid />
                  </div>
                )}
                {activeTab === "tab10" && (
                  <div>
                    <AccessControlType />
                  </div>
                )}
                {activeTab === "tab11" && (
                  <div>
                    <GroupGate />
                  </div>
                )}
                
                {/* {activeTab === "tab6" && (
                          <div>
                              <Brand/>
                          </div>
                          )}
                          {activeTab === "tab7" && (
                          <div>
                              <Company/>
                          </div>
                          )} */}
              </div>

            </div>
          </div>
        </div>
      </section>
    </>
  );
}
export default Configuration;
